module.exports = __webpack_public_path__ + "flash-share-icon-a26d5040.jpg";